<button matIconButton type="button" class="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<h4 mat-dialog-title>{{ 'trace.create-route.generalinfo-title' | translate }}</h4> 

<!-- -->
<div mat-dialog-content class="mat-typography" >
    <form [formGroup]="editorForm" (ngSubmit)="(false)" novalidate>
        <div class="metadata">
          <div class="nameContainer">
            <mat-form-field  appearance="outline" hintLabel="{{ 'trace.max-length' | translate }} {{data.maxNameLength }}" class="form-element">
              <mat-label>{{ "trace.field.name" | translate }}</mat-label>
              <input matInput type="text" name="metadata_name" #metadata_name 
                 formControlName="name"
               />
              <mat-hint align="end">{{ metadata_name.value?.length || 0 }}/{{data.maxNameLength }}</mat-hint>
            </mat-form-field>
          </div>

          <div class="descContainer">
            <!--
            old method with textarea
            <mat-form-field  appearance="outline" hintLabel="{{ 'trace.max-length' | translate }}  1000"
              class="form-element">
              <mat-label>{{ "trace.field.description" | translate }}</mat-label>
              <textarea name="metadata_desc" #metadata_desc matInput formControlName="desc"
                cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="12"
                [pattern]="'^(.|\\n|\\r\\n){0,' + data.maxDescriptionLength + '}$'"
                ></textarea>
              <mat-hint align="end">{{ metadata_desc.value?.length || 0 }}/{{data.maxDescriptionLength}}</mat-hint>
            </mat-form-field>
             -->

              <mat-form-field appearance="outline" hintLabel="{{ 'trace.max-length' | translate }} {{data.maxDescriptionLength}}" class="form-element">
                <mat-label>{{ "trace.field.description" | translate }}</mat-label>
                <quill-material
                  name="metadata_desc"
                  formControlName="desc"
                ></quill-material>
                <mat-hint align="end">{{ descLength || 0 }}/{{data.maxDescriptionLength}}</mat-hint>
              </mat-form-field> 


          </div>
        </div>
      </form>
</div>

    <mat-dialog-actions align="center" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
        <div class="button-container">
            <button mat-flat-button cdkFocusInitial
            color="primary" 
             [mat-dialog-close]="update()"
             [ngClass]="{'mat-button-disabled': !editorForm.valid}" 
             [disabled]="!editorForm.valid">
             {{"trace.create-route.save" | translate}}</button>
        </div>
        <div class="button-container">
          <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.cancel"|translate}}</a>
      </div>
    </mat-dialog-actions>
    
